export enum  MaritalStatus{

    SINGLE = 'SINGLE' ,   // Soltero

    MARRIED = 'MARRIED' ,  //Casado

    WIDOW = 'WIDOW',

    DIVORCED = 'DIVORCED',

    UNMARRIED_PARTNERS = 'UNMARRIED_PARTNERS',

    OTHER = 'OTHER'
}